import { Routes, Route } from 'react-router'
import Landing from './pages/Landing'
import Dogs from './pages/Dogs'
import Dog from './pages/Dog'
import DogSegment from './pages/DogSegment'
import Plan from './pages/Plan'
import PlanBuild from './pages/PlanBuild'
import CheckoutPage from './pages/Checkout'
import CheckoutSuccessPage from './pages/CheckoutSuccess'
import DogsLayout from './components/DogsLayout'
import SegmentLayout from './components/SegmentLayout'
import Session from './components/Session'
import App from './App'
import UserInfo from './pages/UserInfo'

export default function Router() {
	return (
		<Routes>
			<Route path="/" element={<App />}>
				<Route path="/" index element={<Landing />} />
				<Route element={<Session />}>
					<Route path="me" element={<UserInfo />} />
					<Route path="dogs" element={<DogsLayout />}>
						<Route index element={<Dogs />} />
						<Route path=":dog">
							<Route index element={<Dog />} />
							<Route path="plan">
								<Route index element={<Plan />} />
								<Route path="build" element={<PlanBuild />} />
							</Route>
							<Route path=":segment" element={<SegmentLayout />}>
								<Route index element={<DogSegment />} />
							</Route>
						</Route>
					</Route>
					<Route path="/checkout">
						<Route index element={<CheckoutPage />} />
						<Route path="success" element={<CheckoutSuccessPage />} />
					</Route>
				</Route>
			</Route>
		</Routes>
	)
}
